import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

import { submitResetPassword } from 'cognito/auth';

const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const CODE_PATTERN = /^[0-9]{1,8}$/;
const MIN_PASSWORD_LENGTH = 10;

function PasswordReset ()
{
    const navigate = useNavigate ();

    const [ email, setEmail ] = useState ( localStorage.getItem ( "email" ) ? localStorage.getItem ( "email" ) : "" );
    const [ code, setCode ] = useState ( "" );
    const [ password, setPassword ] = useState ( "" );
    const [ confirmPassword, setConfirmPassword ] = useState ( "" );
    
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const [ isPasswordTouched, setIsPasswordTouched ] = useState ( false );
    const [ isConfirmPasswordTouched, setIsConfirmPasswordTouched ] = useState ( false );

    const doSignIn = async () =>
    {
        setError ( { isError: false, message: null } );
        setIsLoading ( true );

        try
        {
            const result = await submitResetPassword ( email, password, code );
            console.log ( result );
            localStorage.setItem ( "email", email );
            setError ( { isError: false, message: null } );
            setIsLoading ( false );

            navigate ( '/participant/login' );
        }
        catch ( error )
        {
            setError ( { isError: true, message: error.name } );
            setIsLoading ( false );
        }
    }

    const isInputValid = () =>
    {
        return EMAIL_PATTERN.test ( email ) && 
                CODE_PATTERN.test ( code ) &&
                password.length >= MIN_PASSWORD_LENGTH && password === confirmPassword
    }

    const doesNotMatch = !isConfirmPasswordTouched || password === confirmPassword ? null : <span className="bg-pgred text-pgwhite font-bold inline-block m-2 p-2 rounded-lg">Passwords do not match</span>
    const tooShort = !isPasswordTouched || password.length >= MIN_PASSWORD_LENGTH ? null : <span className="bg-pgred text-pgwhite font-bold inline-block m-2 p-2 rounded-lg">Password is too short</span>    

    return  <div className="w-full sm:w-4/6 md:w-3/6 m-auto">
                <h1>Reset Password</h1>
                <form>
                    { error.isError && <Error message={error.message} /> }
                    <LabelledInput id="email" label="Email" value={email} onChange={ ( newValue ) => setEmail ( newValue ) } type="email" />
                    <LabelledInput id="code" label="If your email is registered, we've sent you a code to enter below" value={code} onChange={ ( newValue ) => setCode ( newValue ) } type="email" />
                    <LabelledInput id="password" label="New Password" error={tooShort} onChange={ ( newValue ) => setPassword ( newValue ) } type="password" onBlur={ () => setIsPasswordTouched ( true ) }/>
                    <LabelledInput id="confirmPassword" label="Confirm New Password" error={doesNotMatch} value={confirmPassword} onChange={ ( newValue ) => setConfirmPassword ( newValue ) } type="password" onBlur={ () => setIsConfirmPasswordTouched ( true ) } />
                    <div className="flex-row gap-8">
                        <button onClick={ () => doSignIn () } disabled={ !isInputValid () || isLoading } type="submit">Reset Password</button>
                    </div>
                </form>
            </div>
}

export default PasswordReset;